import * as S from './style';

export interface DividerProps {
  marginLeft?: number;
  marginRight?: number;
  marginXAxis?: number;
}

export default function Divider({ marginLeft, marginRight, marginXAxis }: DividerProps) {
  return <S.Wrapper marginLeft={marginLeft} marginRight={marginRight} marginXAxis={marginXAxis} />;
}
